import { useQuery } from '@tanstack/react-query';

import { GetTokenResponse } from '@/api/sofarApi/types';
import { axios } from '@/common/axios';
import { ExtractFnReturnType, QueryConfig } from '@/common/react-query';

export const getGenerateApiToken = async (): Promise<GetTokenResponse> => {
    return axios.get<GetTokenResponse, GetTokenResponse>('/fetch/generate-token');
};

type QueryFnType = typeof getGenerateApiToken;

type UseGenerateApiTokenOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useGenerateApiToken = ({ config }: UseGenerateApiTokenOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['sofar-api-token'],
        queryFn: getGenerateApiToken,
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
